import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Subscription } from 'rxjs';

import { NotificationTime } from '@shared/restaurant/enums';
import { Notification, Party } from '@shared/party/models';
import { LabelsEnum } from '@shared/sms/enums';
import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';
import { ClockService } from '@tablesready/frontend-alerts-bar';

export interface NotifyActions<T> {
  smsPage: (party: T) => void;
  disableMessageButton: (party: T) => boolean;
  mergeInboundOutbound: (party: T) => Notification[];
  voicePage?: (party: T) => void;
}

const RENDERED_LABELS = new Set<LabelsEnum>([
  LabelsEnum.chat,
  LabelsEnum.ready,
  LabelsEnum.toGoOrderReady,
]);

@Component({
  selector: 'tablesready-waitlist-notify',
  templateUrl: './waitlist-notify.component.html',
  styleUrls: ['./waitlist-notify.component.scss'],
  standalone: false,
})
export class WaitlistNotifyComponent<T extends Party> implements OnInit {
  @Input() hideButtons = false;
  @Input() voicePageNotificationEnabled = false;
  @Input() notificationTime = NotificationTime.Relative;
  @Input() party?: T;
  @Input() timezone?: string;
  @Input() togoMode = false;
  @Input() index = 0;
  @Input() notifyActions?: NotifyActions<Party>;
  @Input() isMobile = false;
  @Input() messages?: Notification[];
  @Input() showViewAllLink = false;
  @Output() viewAllClick = new EventEmitter<void>();

  now: number;
  notificationTimeEnum = NotificationTime;
  callBtnFocus: Record<number, boolean> = { };
  icon = AppIcon;
  color = AppIconColor;
  notificationLabelsEnum = LabelsEnum;

  private readonly subscription = new Subscription();

  constructor(private readonly clockService: ClockService) {}

  ngOnInit(): void {
    const timeSub = this.clockService.clock$
      .subscribe((now) => {
        this.now = now;
      });

    this.subscription.add(timeSub);
  }

  get displayMessages(): Notification[] {
    if (this.messages) {
      return this.messages;
    }

    return this.notifyActions?.mergeInboundOutbound(this.party as Party)
      ?? [];
  }

  shouldRender(msg: Notification): boolean {
    if (this.messages) {
      return true;
    }

    return !msg.label
      || msg.type === 'voice'
      || RENDERED_LABELS.has(msg.label)
      || msg.status_sent === 'not_sent';
  }
}
